import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import S3Upload      from 's3_upload';

import Const         from 'fw_const';
import Utils         from 'utils';
// -------------------------------------------------------

class Report extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      event : {},
      complete_url : [],
      update_urls : [],
      insight_modal : false,
    };
  }
  // -------------------------------------------------------
  
  /*
   * イベント設定
   */
  setEvent(column, ev) {
    let event = this.state.event;
    event[column] = ev;
    this.setState({ event: event });
  }
  // -------------------------------------------------------
  
  /*
   * データ更新時反映
   */
  actionProgress() {
    let update_urls = this.state.update_urls;
    let complete_url = this.state.complete_url;
    
    let media = this.state.event.get_media.bind(this)();
    for( let i in media ){
      let d = media[i];
      if( d.is_complete == true ){
        update_urls.push({ contents_id: this.props.data.contents_id, url: d.url });
        complete_url.push(d.url);
      }
    }
    this.setState({ update_urls: update_urls, complete_url: complete_url });
    
    if( media[0].file_count == complete_url.length ){
      this.updateInsight.bind(this)(update_urls);
      this.setState({ update_urls: [] });
    }
  }
  // -------------------------------------------------------
  
  updateInsight(urls) {
    Utils.request.bind(this)('/api/project/workflow/update_insights', { project_id: this.props.data.project_id, urls: urls },
      function(res){
        alert('アップロードしました！');
        location.reload();
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    let event = this.state.event;
    
    return (
      <div id="project">
        <S3Upload setEvent={this.setEvent.bind(this)} actionProgress={this.actionProgress.bind(this)} />
        
        <div className="project-qr-upload">
          <h1>インサイト提出</h1>
          
          <img className="thumbnail" src={data.post.thumbnail} />
          <a href={'https://www.instagram.com/p/'+ data.post.shortcode} target="_blank">URL</a>
          
          <label>
            <input type="file" name="example" size="30" multiple onChange={(e) => { event.file_upload.bind(this)(e, 'insight/', { contents_id: this.props.contents_id }) }} />
            <span>アップロードする</span>
          </label>
          
          <h4>アップロード済みのインサイトデータ</h4>
          { (data.insight.length == 0) && <p className="none">未アップロード</p> }
          <ul>
            { data.insight.map((d, key) => {
              return (
                <li key={key}>
                  <img src={d.file_url} />
                </li>
              );
            })}
          </ul>
          
        </div>
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default Report;